export const label = ({ big, textAlign, marginBottom, marginTop, theme: { colors } }) => ({
    fontSize: big ? '14px' : '12px',
    lineHeight: big ? 1.36 : 1.25,
    letterSpacing: big ? '0.3px' : '0.1px',
    color: colors.blueGrey4,
    marginBottom,
    marginTop,
    textAlign,
});
